import React from 'react';
import styles from './Calendar.module.scss';
import CalendarTabs from '../../../../../molecule/calendarTabs/CalendarTabs';

const Calendar = ({ id, activeTab, activeYearId, setActiveYearId, tabs }) => {
  return (
    <div className={styles['calendar-container']}>
      <CalendarTabs
        id={id}
        activeTab={activeTab}
        activeYearId={activeYearId}
        setActiveYearId={setActiveYearId}
        tabs={tabs}
      />
    </div>
  );
};

export default Calendar;
